"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _semanticUiReact = require("semantic-ui-react");

var _moment = _interopRequireDefault(require("../../../lib/moment"));

var _Fonts = require("../../00_environment/Fonts");

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _LoadingPlaceHolder = _interopRequireDefault(require("../../01_atoms/LoadingPlaceHolder"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _RidesList = _interopRequireDefault(require("../../02_molecules/RidesList"));

var _PlaceHolder = _interopRequireDefault(require("../../02_molecules/PlaceHolder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GenericTripsListPage = function GenericTripsListPage(props) {
  var sdk = props.sdk,
      origin = props.origin,
      destination = props.destination,
      date = props.date,
      rides = props.rides,
      isReturn = props.isReturn,
      _props$onTripSelect = props.onTripSelect,
      onTripSelect = _props$onTripSelect === void 0 ? function () {} : _props$onTripSelect,
      _props$onBack = props.onBack,
      onBack = _props$onBack === void 0 ? function () {} : _props$onBack,
      numberOfPassengers = props.numberOfPassengers;
  var _sdk$i18n = sdk.i18n,
      translationManager = _sdk$i18n.translationManager,
      translatorForNamespace = _sdk$i18n.translatorForNamespace;
  var t = translatorForNamespace('GenericTripListPageUI');
  var content = null; // Set moment locale

  _moment["default"].locale(translationManager.getCurrentLanguage());

  var title = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }, "".concat(isReturn ? t('Return') : t('Outbound'), ": "), sdk.terminals.nameFromId(origin), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "arrow right",
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }), sdk.terminals.nameFromId(destination));

  if (!rides) {
    content = /*#__PURE__*/_react["default"].createElement(_LoadingPlaceHolder["default"], null);
  } else if (_checkTypes["default"].emptyArray(rides)) {
    content = /*#__PURE__*/_react["default"].createElement(_PlaceHolder["default"], {
      title: t('No rides found for this trip'),
      icon: "bus",
      content: /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: onBack
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "arrow left",
        style: {
          display: 'inline',
          lineHeight: (0, _Fonts.withDefaultButtonFont)({}).fontSize,
          marginRight: 5
        }
      }), /*#__PURE__*/_react["default"].createElement("span", null, t('Try other dates')))
    });
  } else {
    // Display them
    content = /*#__PURE__*/_react["default"].createElement(_RidesList["default"], {
      rides: rides,
      numberOfPassengers: numberOfPassengers,
      onRideClick: onTripSelect,
      translator: t,
      title: title,
      onBack: onBack
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: title,
    onBack: onBack,
    topBarRightChildren: /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginRight: 20
      }
    }, (0, _moment["default"])(date).format('DD MMM YYYY'))
  }, content);
};

var _default = GenericTripsListPage;
exports["default"] = _default;